module.exports = __webpack_public_path__ + "img/zt1.197e742e.svg";